// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: relative;
}
.layout {
  flex-grow: 1;
  padding-left: 5%;
  padding-right: 5%;
}

.hover-label {
  cursor: pointer;
  font-size: 16px;
  color: #000;
}

.hover-image {
  position: absolute;
}

.legend-style-main {
  border: 1px solid #dfe1e5 !important;
  border-radius: 4px !important;
  background-color: white;
  align-items: center;
  margin: 0;
  margin-bottom: 10px;
  padding: 5px;
}

.fieldset-style-main {
  border: 1px solid #dfe1e5 !important;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 10px !important;
}

.pdf-container {
  border: 2px solid #dfe1e5 !important;
  align-items: center;
  align-content: center;
  text-align: center;
  font-weight: 700;
  border-radius: 10px;
  padding-top: 15px !important;
  padding-bottom: 10px !important;
}

.Centered {
  display: inline-block;
  vertical-align: middle;
  margin-bottom: 10px;
}

.MuiFormControl-fullWidth .input-style {
  margin-bottom: 10px !important;
  margin-left: 0 !important;
}

.zoom {
  max-width: 310;
}

.search-box-label {
  width: 15%;
  font-size: 18px;
  font-weight: bold;
  color: #2563eb;
  align-content: center;
  padding-left: 5%;
}

.item-container {
  background-color: white;
  padding: 5px;
  text-align: center;
  margin-bottom: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);
  border: 1px solid #dbcfcf;
}

.bold-text {
  font-weight: 900;
}

.MuiTypography-root.MuiTypography-h6.css-1ibml7n-MuiTypography-root {
  font-weight: 900;
}

.header {
  text-align: center;
  font-size: 45px;
  font-weight: 700;
  font-family: ui-sans-serif, system-ui, sans-serif, Segoe UI Emoji,
    Segoe UI Symbol, Noto Color Emoji !important;
}

.sub-head {
  text-align: center;
  font-size: 1rem;
}

@media (max-width: 899px) {
  .header {
    font-size: 25px;
  }

  .sub-head {
    font-size: 0.7rem;
  }

  .margin-top-sec {
    margin-top: -30px;
  }
  .margin-top-div {
    margin-top: -20px;
  }
}

.MuiGrid-item {
  padding-top: 9px !important;
  padding-bottom: 10px !important;
}
.MuiGrid-item .MuiGrid-grid-xl-5\\.5 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/home/Home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,4CAA4C;EAC5C,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;gDAC8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC","sourcesContent":[".container {\n  position: relative;\n}\n.layout {\n  flex-grow: 1;\n  padding-left: 5%;\n  padding-right: 5%;\n}\n\n.hover-label {\n  cursor: pointer;\n  font-size: 16px;\n  color: #000;\n}\n\n.hover-image {\n  position: absolute;\n}\n\n.legend-style-main {\n  border: 1px solid #dfe1e5 !important;\n  border-radius: 4px !important;\n  background-color: white;\n  align-items: center;\n  margin: 0;\n  margin-bottom: 10px;\n  padding: 5px;\n}\n\n.fieldset-style-main {\n  border: 1px solid #dfe1e5 !important;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);\n  border-radius: 5px;\n  margin-bottom: 10px;\n  padding: 10px !important;\n}\n\n.pdf-container {\n  border: 2px solid #dfe1e5 !important;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  font-weight: 700;\n  border-radius: 10px;\n  padding-top: 15px !important;\n  padding-bottom: 10px !important;\n}\n\n.Centered {\n  display: inline-block;\n  vertical-align: middle;\n  margin-bottom: 10px;\n}\n\n.MuiFormControl-fullWidth .input-style {\n  margin-bottom: 10px !important;\n  margin-left: 0 !important;\n}\n\n.zoom {\n  max-width: 310;\n}\n\n.search-box-label {\n  width: 15%;\n  font-size: 18px;\n  font-weight: bold;\n  color: #2563eb;\n  align-content: center;\n  padding-left: 5%;\n}\n\n.item-container {\n  background-color: white;\n  padding: 5px;\n  text-align: center;\n  margin-bottom: 10px;\n  border-radius: 4px;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);\n  border: 1px solid #dbcfcf;\n}\n\n.bold-text {\n  font-weight: 900;\n}\n\n.MuiTypography-root.MuiTypography-h6.css-1ibml7n-MuiTypography-root {\n  font-weight: 900;\n}\n\n.header {\n  text-align: center;\n  font-size: 45px;\n  font-weight: 700;\n  font-family: ui-sans-serif, system-ui, sans-serif, Segoe UI Emoji,\n    Segoe UI Symbol, Noto Color Emoji !important;\n}\n\n.sub-head {\n  text-align: center;\n  font-size: 1rem;\n}\n\n@media (max-width: 899px) {\n  .header {\n    font-size: 25px;\n  }\n\n  .sub-head {\n    font-size: 0.7rem;\n  }\n\n  .margin-top-sec {\n    margin-top: -30px;\n  }\n  .margin-top-div {\n    margin-top: -20px;\n  }\n}\n\n.MuiGrid-item {\n  padding-top: 9px !important;\n  padding-bottom: 10px !important;\n}\n.MuiGrid-item .MuiGrid-grid-xl-5\\.5 {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
